// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2ZRej","text":"SelectPayment_text__10Q7k","title":"SelectPayment_title__2yWAY","btn":"SelectPayment_btn__vthJ8"};